import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

import { ClientPanel } from "@/data/models/ClientPanel";

const name = "clientPanel";

import store from "@/store";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class ClientPanelVuexModule extends VuexModule {

  clientPanelCache = new Map<string, ClientPanel>();

  @Mutation
  cacheClientPanel(clientPanel: ClientPanel) {
    this.clientPanelCache.set(clientPanel.serialNumber, clientPanel);
  }

  @Mutation
  clear() {
    this.clientPanelCache.clear()
  }

  get cachedClientPanel() {
    const cache = this.clientPanelCache;

    return function(serialNumber: string) {
      return cache.get(serialNumber);
    };
  }
}

export const ClientPanelModule = getModule(ClientPanelVuexModule);
